import api from '@/api/alumniManagement'

const state = {

}

const actions = {
  uploadAlumniFile (context, file) {
    return api.uploadAlumniFile(file)
  },
  getAlumniList () {
    return api.getAlumniList()
  },
  getAlumni (context, alumniId) {
    return api.getAlumni(alumniId)
  },
  createAlumni (context, alumniData) {
    return api.createAlumni(alumniData)
  },
  updateAlumni (context, alumniData) {
    return api.updateAlumni(alumniData)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
